import { Zap } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, Flex, Text } from '@/components/common';

interface LiveTodayExplainerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function LiveTodayExplainerDialog({ open, onOpenChange }: LiveTodayExplainerDialogProps) {
  const { t } = useTranslation('discover');

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Content
        size="2"
        maxWidth="320px"
        aria-describedby={undefined}
        data-testid="live-today-explainer"
      >
        <Dialog.Title className="sr-only">{t('header.liveTodayExplainer.title')}</Dialog.Title>

        <Flex direction="column" align="center" gap="4">
          <Flex
            align="center"
            justify="center"
            data-accent-color="green"
            className="shrink-0 rounded-full bg-accent-9 p-3"
          >
            <Zap size={28} color="var(--accent-contrast)" />
          </Flex>

          <Flex direction="column" align="center" gap="1">
            <Text size="3" weight="bold" className="text-center">
              {t('header.liveTodayExplainer.title')}
            </Text>
            <Text size="2" color="gray" className="text-center leading-tight">
              {t('header.liveTodayExplainer.description')}
            </Text>
          </Flex>

          <Dialog.Close>
            <Button
              type="button"
              size="md"
              className="w-full"
              data-testid="live-today-explainer-dismiss"
            >
              {t('header.liveTodayExplainer.dismiss')}
            </Button>
          </Dialog.Close>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
